let unlinkSdk = null;
let unlinkSdk_memoryStore = []; // tmp

export async function initSDK({rpcUrl}) {
  const { UnlinkSDK } = await import('@unlink/js-sdk');


  unlinkSdk = new UnlinkSDK({
    rpcUrl,
    fragmentAdapter: {
        async loadFragments() {
        return unlinkSdk_memoryStore; // tmp should be db
      },
      async storeFragments(fragments) {
        unlinkSdk_memoryStore = fragments; // tmp should be db
      }
    },
  });

  // initialize fragments
  await unlinkSdk.initializeFragments();
}

export function getSDK() {
  if (!unlinkSdk) throw new Error("Unlink SDK not initialized");
  return unlinkSdk;
}